import React from 'react'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import DataPanel from 'components/theme/DataPanel'
import { totalVisitsSelector, totalResponsesSelector } from 'selectors'
import language from 'utils/vast-languagepack'

export default connect(
	(state) => ({
		formCount: Object.keys(state.signupForm.forms).length,
		totalVisits: totalVisitsSelector(state),
		totalResponses: totalResponsesSelector(state),
	}),
	null,
)(({ formCount, totalVisits, totalResponses }) => (
	<Grid container spacing={16}>
		<Grid item xs={4}>
			<DataPanel
				value={
					totalVisits ? Math.round((totalResponses / totalVisits) * 100) : null
				}
				property={language.signupform.add.responded}
				arcGauge
				color="green"
				label={`${totalResponses} ${language.signupform.viewAll.stats.totalResponses}`}
			/>
		</Grid>
		<Grid item xs={4}>
			<DataPanel
				value={totalVisits}
				color="orange"
				label={language.signupform.viewAll.stats.totalVisits}
			/>
		</Grid>
		<Grid item xs={4}>
			<DataPanel
				value={formCount}
				color="pink"
				label={language.signupform.viewAll.stats.totalForms}
			/>
		</Grid>
	</Grid>
))
